export { CollectionsIcon } from './collections'
